module.exports = __webpack_public_path__ + "img/CSA_preview.png";